module.exports = __webpack_public_path__ + "img/map.5e1a2ede.webp";